import { ColumnDef, useModal } from "@commonlibs";
import type { ReleaseStrategyDto } from "common/models/api/models/ReleaseStrategyDto";
import useTranslate from "ui/locale/hooks/useTranslate";
import ActionsMenu from "ui/common/components/input/ActionsMenu/ActionsMenu";
import ModifyReleaseStrategyModal from "../components/ModifyReleaseStrategyModal/ModifyReleaseStrategyModal";
import BlockAdminModal from "../components/BlockAdminModal/BlockAdminModal";
import CreateAdminModal from "../components/CreateAdminModal/CreateAdminModal";

export enum ADMIN_COLUMNS {
    PARTNER_OR_ADMIN = "partnerOrAdmin",
    ADMIN_NAME = "adminName",
    EMAIL = "email",
    RELEASER_NAME = "releaserName",
    RELEASER_PHONE = "releaserPhone",
    RELEASER_EMAIL = "releaserEmail",
    ACTIONS = "actions",
}

export const ADMIN_COLUMNS_KEYS = Object.values(ADMIN_COLUMNS);

export function useAdminColumns(): ColumnDef<ReleaseStrategyDto>[] {
    const translate = useTranslate();
    const { showModal } = useModal();

    return [
        {
            accessorKey: ADMIN_COLUMNS.PARTNER_OR_ADMIN,
            header: translate("partner/admin"),
            size: 200,
            align: "left",
            alignCells: "left",
            accessorFn: (row) => row.name,
        },
        {
            accessorKey: ADMIN_COLUMNS.ADMIN_NAME,
            header: translate("adminName"),
            size: 250,
            align: "left",
            alignCells: "left",
            accessorFn: (row) => row.admin.name,
        },
        {
            accessorKey: ADMIN_COLUMNS.EMAIL,
            header: translate("email"),
            size: 200,
            align: "left",
            alignCells: "left",
            accessorFn: (row) => row.admin.email,
        },
        {
            accessorKey: ADMIN_COLUMNS.RELEASER_NAME,
            header: translate("releaserName"),
            size: 200,
            align: "left",
            alignCells: "left",
            accessorFn: (row) => row.approver?.name,
        },
        {
            accessorKey: ADMIN_COLUMNS.RELEASER_PHONE,
            header: translate("releaserPhone"),
            size: 200,
            align: "left",
            alignCells: "left",
            accessorFn: (row) => row.approver?.phone,
        },
        {
            accessorKey: ADMIN_COLUMNS.RELEASER_EMAIL,
            header: translate("releaserEmail"),
            size: 200,
            align: "left",
            alignCells: "left",
            accessorFn: (row) => row.approver?.email,
        },
        {
            accessorKey: ADMIN_COLUMNS.ACTIONS,
            header: () => "",
            size: 60,
            cell: (info) => info.getValue(),
            accessorFn: (row) => (
                <ActionsMenu
                    actions={[
                        {
                            label: "modifyAdmin",
                            onClick: () => showModal(CreateAdminModal, { admin: row.admin }),
                        },
                        {
                            label: "modifyReleaseStrategy",
                            onClick: () =>
                                showModal(ModifyReleaseStrategyModal, {
                                    releaseStrategy: row,
                                }),
                        },
                        ...(row.admin?.id != null
                            ? [
                                  {
                                      label: "blockAdmin" as const,
                                      onClick: () =>
                                          showModal(BlockAdminModal, {
                                              releaseStrategy: row,
                                          }),
                                  },
                              ]
                            : []),
                    ]}
                />
            ),
            enableSorting: false,
        },
    ];
}
